import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import NativeSelect from '@material-ui/core/NativeSelect';
import Input from '@material-ui/core/Input';

import { useUserDataContext } from '../../../../wiring/user-provider';
import StateList from './state-list';

import Styles from './selectMenuNativeStyles';

import useI18n from '../../../../utils/use-i18n';
import slugify from '../../../../utils/slugify';
import ContentEnglish from './i18n/en';
import ContentSpanish from './i18n/es';

const content = {
    en: ContentEnglish,
    es: ContentSpanish,
};

const NativeSelects = ({ classes }) => {
    const { selectedState } = useUserDataContext();
    const history = useHistory();
    const [selectedValue, setSelectedValue] = useState(selectedState);
    const handleChange = (event) => {
        const { value } = event.target;
        history.push(value ? `/state/${slugify(value)}` : '/');
    };

    useEffect(() => {
        setSelectedValue(selectedState);
    }, [selectedState]);

    return (
        <NativeSelect
            value={selectedValue}
            name="state"
            onChange={handleChange}
            className={classes.selectEmpty}
            classes={{
                root: classes.root,
            }}
            input={
                <Input
                    classes={{
                        underline: classes.underline,
                        input: classes.input,
                    }}
                />
            }>
            <option value="">{useI18n('label_native', content)}</option>
            {StateList.map((state) => (
                <option key={state} value={state}>
                    {state}
                </option>
            ))}
        </NativeSelect>
    );
};

NativeSelects.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(Styles)(NativeSelects);
